<ng-container>
  <div class="card lighter-shade-1">
    <div class="row gray pad-10 flex-center gray-1">
      <div class="column six vehicle-info-container pad-right-5">
        @if (enableResetCoverage) {
          <ds-premium-cost
            [monthlyPremium]="vehicleCurrentRate.priorMonthly"
            [title]="'Current'"
            [totalCost]="vehicleCurrentRate.priorCost"
            [termMonths]="vehicleCurrentRate.termMonths"
          ></ds-premium-cost>
        }
        @if (!enableResetCoverage) {
          <div class="semi-bold">
            <div>Current Premium</div>
            <div><span class="icon-auto margin-right-10"></span> {{ vehicleName }}</div>
          </div>
        }
      </div>
      <div class="column six pad-left-5">
        @if (!canRecalculate || enableResetCoverage) {
          <ds-premium-cost
            [monthlyPremium]="vehicleCurrentRate.monthlyPremium"
            [title]="enableResetCoverage ? 'Estimated' : null"
            [totalCost]="vehicleCurrentRate.totalCost"
            [termMonths]="vehicleCurrentRate.termMonths"
          ></ds-premium-cost>
        }
        @if (canRecalculate && !enableResetCoverage) {
          <div class="semi-bold">
            <div>Recalculate for estimate</div>
          </div>
        }
      </div>
    </div>
    <div class="row text-center pad-top-10">
      <button
        [disabled]="!canRecalculate"
        [class.capitalize]="!isPartner"
        ds-button
        class="-outline-white recalculate-button"
        data-cy="sidebarQuoteRecalcButton"
        (click)="this.recalculate()"
      >
        Recalculate
      </button>
    </div>
    <div class="row text-center reset-link">
      <a
        data-cy="sidebarQuoteResetLink"
        (click)="resetQuote.emit()"
        [class.disabled]="!enableResetCoverage"
        >Reset Coverage</a
      >
    </div>
  </div></ng-container
>
